import React from 'react';
import { withModalControlsHook, ModalComponentProps } from 'components/modals/with-modal-controls-hook';
import { ExclusiveMenuGateModal } from './exclusive-menu-gate-modal';

export type OnOpenDataValue = {
  isAccessibleToCurrentUser?: boolean;
  isLoggedIn?: boolean;
};

export type OnCloseResolvedValue = undefined;

const ExclusiveMenuGateModalWrapper = (props: ModalComponentProps<OnOpenDataValue>): JSX.Element => (
  <ExclusiveMenuGateModal {...props} />
);

const [ExclusiveMenuGateController, useExclusiveMenuGateModal] = withModalControlsHook(ExclusiveMenuGateModalWrapper);

export { useExclusiveMenuGateModal, ExclusiveMenuGateController };
